module.exports = __webpack_public_path__ + "assets/img/block-right-6ee7ae8a.png";